import React, { useEffect, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";

import { all_routes } from "../../../Router/all_routes";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { setToogleHeader } from "../../../core/redux/action";
import {
  ArrowLeft,
  ChevronDown,
  ChevronUp,
  Info,
  PlusCircle,
  Trash2,
} from "feather-icons-react/build/IconComponents";
import { useDispatch, useSelector } from "react-redux";
import apiHandler from "../../common/api";
import withReactContent from "sweetalert2-react-content";
import Swal from "sweetalert2";
import "sweetalert2/dist/sweetalert2.min.css";
import LoadingSpinner from "../../../InitialPage/Sidebar/LoadingSpinner";

const AddCategory = () => {
  const Parms = useParams();
  const navigate = useNavigate();
  console.log(Parms.id, "ID");
  const MySwal = withReactContent(Swal);

  const route = all_routes;
  const dispatch = useDispatch();

  const data = useSelector((state) => state.toggle_header);
  const userData = useSelector((state) => state.user_data);
  const renderCollapseTooltip = (props) => (
    <Tooltip id="refresh-tooltip" {...props}>
      Collapse
    </Tooltip>
  );

  const [formvalue, setformvalue] = useState({
    loginUser: userData?.id,
    businessId: userData?.businessId,
  });


  const [dataset, setdata] = useState([{ categoryName: "", ID: 0 }])

  const [Categorylist, setCaegorylist] = useState([]);
  const [loading, setLoading] = useState(false);
  console.log(Categorylist, "Categorylist");

  const HandleChange = (e, index) => {
    console.log(e, "event");


    const { name, value } = e.target;

    setdata((prev) => prev.map((item, i) => i === index ? { ...item, [name]: value } : item));

  };

  const handleDelete = (index) => {
    const newDataset = [...dataset];
    newDataset.splice(index, 1);
    setdata(newDataset);
  };



  console.log(dataset, "formvalue");
  const HandleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true)


    const response = await apiHandler({
      method: "POST",
      route: "Business/CategoryUpsert",
      payload: { ...formvalue, categoryList: dataset },
    });
    const ResponseID = response?.ResponseID
    console.log(ResponseID, "check responce ID")
    if (response.ResponseCode === "SUCCESS") {
      console.log(response, "data");
      setLoading(false)
      MySwal.fire({
        // title: "Upsert!",
        // text: "Your file has been Upsert.",
        title: Parms.id > 0 ? "Service Menu Updated!" : "Service Menu Added!",
        text: Parms.id > 0 ? "The Service Menu details have been successfully updated." : "The Service Menu has been successfully added.",
        className: "btn btn-success",
        confirmButtonText: "OK",
        customClass: {
          confirmButton: "btn btn-success",
        },
      }).then((result) => {
        if (result.isConfirmed) {
          navigate(route.Category);
        }
      });
    } else {
      setLoading(false)
      if (ResponseID == -1) {
        MySwal.fire({
          icon: "warning",
          title: "Duplicate Name",
          html: `This service menu is allready exists for this business.`,
          confirmButtonText: "OK",
          confirmButtonColor: "#f8bb86", // optional: yellowish tone
          customClass: {
            confirmButton: "btn btn-warning", // your existing button style
          },
        })
      } else {
        MySwal.fire({
          title: "Error!",
          text:
            response?.ResponseMessage ||
            "Something went wrong. Please try again.",
          icon: "error",
          confirmButtonText: "OK",
          customClass: {
            confirmButton: "btn btn-danger",
          },
        }).then((result) => {
          if (result.isConfirmed) {
            // navigate(route.Category);
          }
        });
      }
    }
  };

  const getCategoryData = async (bId) => {
    const response = await apiHandler({
      method: "GET",
      route: `Business/CategoryAll?businessId=${bId}`,
    });
    if (response.ResponseCode === "SUCCESS") {
      console.log(response, "data");
      setCaegorylist(response.ResponseData);
    } else {
      console.log(response, "data");
    }
  };

  const prodcutDataListApi = async (catId) => {
    const response = await apiHandler({
      method: "GET",
      route: `Business/CategoryById?ID=${catId}`,
    });
    if (response.ResponseCode === "SUCCESS") {
      console.log(response, "data");
      const categoryData = response.ResponseData[0];
      setformvalue({
        ...formvalue,

        loginUser: userData?.id,
        businessId: categoryData?.businessId,
      });
      setdata([{ categoryName: categoryData?.categoryName, ID: categoryData?.ID }])
      getCategoryData(categoryData?.businessId);
    } else {
      console.log(response, "data");
    }
  };

  useEffect(() => {
    if (Parms?.id > 0) {
      prodcutDataListApi(Parms?.id);
    } else {
      getCategoryData(formvalue?.businessId);
    }
  }, []);


  const handleAddMore = () => {
    setdata([...dataset, { categoryName: "", ID: 0 }]);
  }

  return (
    <>
      <LoadingSpinner isLoading={loading} />
      <div className="page-wrapper">
        <div className="content">
          <div className="page-header">
            <div className="add-item d-flex">
              <div className="page-title">
                <h4>New Service Menu</h4>
                <h6>Create new Category</h6>
              </div>
            </div>
            <ul className="table-top-head">
              <li>
                <OverlayTrigger placement="top" overlay={renderCollapseTooltip}>
                  <Link
                    data-bs-toggle="tooltip"
                    data-bs-placement="top"
                    title="Collapse"
                    id="collapse-header"
                    className={data ? "active" : ""}
                    onClick={() => {
                      dispatch(setToogleHeader(!data));
                    }}
                  >
                    <ChevronUp className="feather-chevron-up" />
                  </Link>
                </OverlayTrigger>
              </li>
              <li>
                <div className="d-flex gap-2 page-btn">
                  <button onClick={() => navigate(route.Category)} className="btn btn-primary btn-md btn-wave me-2">
                    <ArrowLeft className="custome-white-color" />
                    Back to Category
                  </button>
                </div>
              </li>
            </ul>
          </div>

          {/* /add */}
          <form onSubmit={HandleSubmit}>
            <div className="card">
              <div className="card-body add-product pb-0">
                <div
                  className="accordion-card-one accordion"
                  id="accordionExample"
                >
                  <div className="accordion-item">
                    <div className="accordion-header" id="headingOne">
                      <div
                        className="accordion-button"
                        data-bs-toggle="collapse"
                        data-bs-target="#collapseOne"
                        aria-controls="collapseOne"
                      >
                        <div className="addproduct-icon">
                          <h5>
                            <Info className="add-info" />

                            <span>Service Menu Information</span>
                          </h5>
                          <Link to="#">
                            <ChevronDown className="chevron-down-add" />
                          </Link>
                        </div>
                      </div>
                    </div>
                    <div
                      id="collapseOne"
                      className="accordion-collapse collapse show"
                      aria-labelledby="headingOne"
                      data-bs-parent="#accordionExample"
                    >
                      <div className="accordion-body">
                        <div className="row">

                          <div className="col-xxl-4 col-xl-4 col-lg-6 col-md-6 col-sm-12 col-12">
                            {dataset.map((data, index) => (
                              <div key={index} className="mb-3 add-product">
                                <label className="form-label">Service Menu Name</label>
                                <div className="d-flex gap-2">
                                  <input
                                    type="text"
                                    name="categoryName"
                                    value={data.categoryName}
                                    onChange={(e) => HandleChange(e, index)}
                                    className="form-control"
                                    required
                                  />
                                  {dataset.length > 1 && (
                                    <button
                                      type="button"
                                      className="btn btn-danger d-flex align-items-center justify-content-center px-3"
                                      onClick={() => handleDelete(index)}
                                      title="Delete Category"
                                    >
                                      <Trash2 size={18} />
                                    </button>
                                  )}
                                </div>
                              </div>
                            ))}
                          </div>
                          <div className="col-xxl-4 col-xl-4 col-lg-6 col-md-6 col-sm-12 col-12">

                          </div >
                          <div className="col-xxl-4 col-xl-4 col-lg-6 col-md-6 col-sm-12 col-12 mt-3">
                            <button onClick={handleAddMore} type="button" className="btn btn-primary">
                              <PlusCircle className="me-2 iconsize" /> Add Category
                            </button>
                          </div>

                        </div>

                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-lg-12">
              <div className="btn-addproduct mb-4">
                <button type="button" className="btn btn-outline-primary btn-md me-2">
                  Cancel
                </button>
                <button type="submit" className=" btn btn-primary btn-md btn-wave me-2">
                  Save Category
                </button>
              </div>
            </div>
          </form>
          {/* /add */}
        </div>
      </div>
    </>
  );
};

export default AddCategory;
